class SampleAddToCart extends HTMLElement {
  constructor() {
    super();

    this.addEventListener('click', () => {
      const ID = this.getAttribute('data-id');
      const image = this.getAttribute('data-image');
      const title = this.getAttribute('data-title');
      const variant = this.getAttribute('data-variant-title');


      this.addToCart(ID, image, title, variant);
    })

  }


  uuidv4() {
    return "10000000-1000-4000-8000-100000000000".replace(/[018]/g, c =>
      (+c ^ crypto.getRandomValues(new Uint8Array(1))[0] & 15 >> +c / 4).toString(16)
    );
  }


  connectedCallback() {
    const localStorageKey = "ecsSamplesMiniCart";
    const stored = localStorage.getItem(localStorageKey);
    const max = parseInt(this.getAttribute('data-max-items'), 10);

    const cartObj = JSON.parse(stored);

    const composition = cartObj?.composition || [];

    const alreadyInCart = composition.some((item) => {
      return item?.id === this.getAttribute('data-id');
    });

    if (alreadyInCart && this.getAttribute('data-a') === "false") {
      this.classList.add('added');
      return
    }


    // remove add to mini cart buttons when max has been reached
    // also enabled real add to cart button
    if (cartObj?.composition.length == max) {
      this.classList.add('visually-hidden');
      document.querySelector('[data-add-to-cart-ref] button').classList.remove('disabled')
      document.querySelector('[data-add-to-cart-ref] button').removeAttribute('disabled')
    } else if (cartObj?.composition.length > max) {
      this.classList.add('visually-hidden');
      document.querySelector('[data-add-to-cart-ref] button').classList.add('disabled')
      document.querySelector('[data-add-to-cart-ref] button').setAttribute('disabled', 'true')
    } else {
      document.querySelector('[data-add-to-cart-ref] button').classList.add('disabled')
      document.querySelector('[data-add-to-cart-ref] button').setAttribute('disabled', 'true')
    }

  }



  async addToCart(id, image, title, variant) {

    // check cart capacity

    const max = this.getAttribute('data-max-items');
    const count = this.getAttribute('data-live-count');

    if (count == max) {
      throw new Error("Minicart is at max capacity.");
      return;
    }

    const formData = {
      id,
      quantity: 1,
      image,
      title,
      variant,
    };

    try {
      const localStorageKey = "ecsSamplesMiniCart";
      const stored = localStorage.getItem(localStorageKey);

      let cartObj = {
        createdAt: Date.now(),
        item: this.getAttribute('data-parent-id'),
        composition: []
      };

      if (stored) {
        try {
          cartObj = JSON.parse(stored);

          if (!Array.isArray(cartObj.composition)) {
            cartObj.composition = [];
          }
        } catch (e) {
          console.warn("Failed to parse existing cart, resetting.");
        }
      }

      cartObj.composition.push(formData);

      localStorage.setItem(localStorageKey, JSON.stringify(cartObj));
      // console.log("Item added:", formData);

      document.querySelector('[data-cart-ref]').renderCart(localStorage.getItem(localStorageKey), true);

      const composition = cartObj?.composition || [];

      const alreadyInCart = composition.some((item) => {
        return item?.id === this.getAttribute('data-id');
      });

    if (alreadyInCart && this.getAttribute('data-a') === "false") {
      this.classList.add('added');
      return
    }
      

    } catch (error) {
      console.error("Error adding to cart:", error);
    }
  }




}

customElements.define("ecs-sample-add-to-cart", SampleAddToCart);




class SampleMiniCart extends HTMLElement {
  constructor() {
    super();
  }

  static get observedAttributes() {
    return ['data-count'];
  }



  connectedCallback() {
    const forcedItems = this.getAttribute('data-f');
  
    const forcedIdsToCheck = forcedItems
      ? JSON.parse(forcedItems).map(id => parseInt(id, 10))
      : [];
  
    const localStorageKey = "ecsSamplesMiniCart";
    const now = Date.now();

    const expiryDays = parseInt(this.getAttribute('data-x'))
    const tenDaysInMs = expiryDays * 24 * 60 * 60 * 1000;
  
    const existing = localStorage.getItem(localStorageKey);
  
    if (existing) {
      try {
        const parsed = JSON.parse(existing);
        const isExpired = parsed.createdAt && (now - parsed.createdAt > tenDaysInMs);
        const composition = parsed?.composition || [];
  
        let needsReset = isExpired;
  
        if (forcedIdsToCheck.length > 0) {
          const indexMismatch = forcedIdsToCheck.some((forcedId, index) => {
            const item = composition[index];
            return !item || parseInt(item.id, 10) !== forcedId;
          });
  
          needsReset ||= (composition.length === 0 || indexMismatch);
        } else {
          const hasForcedItemsInCart = composition.some(item => item?.isForced === true);
          needsReset ||= hasForcedItemsInCart;
        }
  
        if (needsReset) {
          this.createFreshCart(localStorageKey, now);
        } else {
          this.renderCart(existing, false);
        }
      } catch (e) {
        this.createFreshCart(localStorageKey, now);
      }
    } else {
      this.createFreshCart(localStorageKey, now);
    }
  }


  attributeChangedCallback(name, oldValue, newValue) {
    if (name === 'data-count') {

      const count = this.getAttribute('data-count');
      const max = this.getAttribute('data-max-items')

      document.querySelectorAll('[data-selected-items-count]').forEach((el) => {
        el.innerHTML = count;
      })

      document.querySelectorAll('[data-live-count-ref]').forEach((el) => {
        el.setAttribute('data-live-count', count);
      })

      if (count == max) {

        document.querySelector('[data-add-to-cart-ref] button').classList.remove('disabled')
        document.querySelector('[data-add-to-cart-ref] button').removeAttribute('disabled')

        document.querySelector('[data-add-to-cart-ref] button').innerHTML = "Add to bag"


        document.querySelectorAll('ecs-sample-add-to-cart').forEach((el) => {
          el.classList.add('visually-hidden');
        })

      } else if (count > max) {

        document.querySelectorAll('ecs-sample-add-to-cart').forEach((el) => {
          el.classList.add('visually-hidden');
        })

        document.querySelector('[data-add-to-cart-ref] button').innerHTML = "Add to bag"

        document.querySelector('[data-add-to-cart-ref] button').classList.add('disabled')
        document.querySelector('[data-add-to-cart-ref] button').setAttribute('disabled', 'true')

      } else {

        document.querySelectorAll('ecs-sample-add-to-cart').forEach((el) => {
          el.classList.remove('visually-hidden');
        })

        document.querySelector('[data-add-to-cart-ref] button').innerHTML = `Select ${max - count} more`

        document.querySelector('[data-add-to-cart-ref] button').classList.add('disabled')
        document.querySelector('[data-add-to-cart-ref] button').setAttribute('disabled', 'true')

      }
    }
  }



  async createFreshCart(key, timestamp) {

    // check for admin forced items

    let compositionData = [];

    let forcedItems = this.getAttribute('data-f');
    if (forcedItems) {
      const variantIDs = JSON.parse(forcedItems);
      const variantGIDs = variantIDs.map(id => `gid://shopify/ProductVariant/${id}`);

      const SHOPIFY_STOREFRONT_API_URL = 'https://escentric.myshopify.com/api/2025-07/graphql.json';
      const STOREFRONT_ACCESS_TOKEN = '40fd225a07783109214bb76e61638855';

      const VARIANTS_QUERY = `
        query getVariants($ids: [ID!]!) {
          nodes(ids: $ids) {
            ... on ProductVariant {
              id
              title
              quantityAvailable
              image {
                url
              }
              product {
                id
                title
              }
            }
          }
        }
      `;

      function chunkArray(array, size) {
        return Array.from({
            length: Math.ceil(array.length / size)
          }, (_, i) =>
          array.slice(i * size, i * size + size)
        );
      }

      async function fetchVariantChunk(idsChunk) {
        const response = await fetch(SHOPIFY_STOREFRONT_API_URL, {
          method: 'POST',
          headers: {
            'Content-Type': 'application/json',
            'X-Shopify-Storefront-Access-Token': STOREFRONT_ACCESS_TOKEN,
          },
          body: JSON.stringify({
            query: VARIANTS_QUERY,
            variables: {
              ids: idsChunk
            },
          }),
        });

        const json = await response.json();

        if (json.errors) {
          console.error('Storefront API Errors:', json.errors);
          throw new Error('Storefront API returned errors');
        }

        return json.data.nodes;
      }

      async function fetchVariantsByIds(allVariantIds) {
        const chunks = chunkArray(allVariantIds, 10);
        const results = [];

        for (const chunk of chunks) {
          const data = await fetchVariantChunk(chunk);
          results.push(...data);
        }

        return results;
      }

      // fetch products that are forced to form data in minicart
      try {
        const allVariants = await fetchVariantsByIds(variantGIDs);

        // with the returned data, push to the mini cart

        allVariants.map((v) => {
          compositionData.push({
            id: v?.id?.split('/').pop(),
            image: v?.image?.url,
            quantity: 1,
            title: v?.product?.title,
            variant: v?.title,
            isForced: true
          })
        })


        const newCartWithForcedItems = {
          createdAt: timestamp,
          item: this.getAttribute('data-product-id'),
          composition: compositionData
        };

        localStorage.setItem(key, JSON.stringify(newCartWithForcedItems));

        setTimeout(() => {
          this.renderCart(localStorage.getItem(key), false);
        }, 500)


      } catch (err) {
        console.error('Failed to fetch variants:', err);
      }
    } else {

      const newCart = {
        createdAt: timestamp,
        item: this.getAttribute('data-product-id'),
        composition: []
      };

      localStorage.setItem(key, JSON.stringify(newCart));
      this.renderEmpty();

    }


  }

  renderCart(cart, shouldOpen) {

    const _cart = JSON.parse(cart);
    let cartMarkup = ``;

    if (_cart?.composition.length < 1) {

      this.setAttribute('data-count', 0);

      const max = parseInt(this.getAttribute('data-max-items'), 10);
      const placeholderImage = this.getAttribute('data-placeholder-image');
      let loopedHTML = '';

      for (let index = 0; index < max; index++) {
        loopedHTML += `<div class="sampleBuilder__line-empty">
          <img src="${placeholderImage}" alt="Skeleton Image">
          <div>Select Product</div>
        </div>`;
      }

      cartMarkup = loopedHTML;
    } else {

      const maxItems = parseInt(this.getAttribute('data-max-items'));
      const forcedItems = this.getAttribute('data-f');
      const items = _cart?.composition || [];
      const itemsCount = items.length;
      const placeholderImage = this.getAttribute('data-placeholder-image');

      const forcedIdsToCheck = JSON.parse(forcedItems) || [];
      const lineItems = _cart?.composition.map((item, i) => {
        const forcedIndex = forcedIdsToCheck.indexOf(parseInt(item?.id));
        const isForced = forcedIndex !== -1 && forcedIndex === i;
      
        return `
          <div class="sampleBuilder__line-item">
            ${!isForced ? `
              <div class="sampleBuilder__line-remove" data-index="${i}" data-id="${item?.id}">
                <svg width="10" height="10" viewBox="0 0 10 10" fill="none">
                  <path d="M0.854016 -0.00259152L-0.000488281 0.828125L9.14426 9.71831L9.99877 8.88759L0.854016 -0.00259152Z" fill="black"/>
                  <path d="M9.99464 1.10415L9.14014 0.273438L-0.0046131 9.16362L0.849891 9.99434L9.99464 1.10415Z" fill="black"/>
                </svg>
              </div>` : ''
            }
            <img src="${item?.image}" alt="Skeleton Image">
            <div>${item?.title}</div>
          </div>
        `;
      }).join('');


      // Build empty placeholders based on how many slots are left
      const emptySlots = maxItems - itemsCount;
      const emptyPlaceholders = Array.from({
        length: emptySlots
      }).map(() => {
        return `
    <div class="sampleBuilder__line-empty">
      <img src="${placeholderImage}" alt="Skeleton Image">
      <div>Select Product</div>
    </div>
  `;
      }).join('');


      cartMarkup = `${lineItems}${emptyPlaceholders}`;

      this.setAttribute('data-count', _cart?.composition?.length)
    }


    this.querySelector('[data-dynamic-cart-ref]').innerHTML = `${cartMarkup}`;

    this.querySelectorAll('.sampleBuilder__line-remove').forEach((el) => {
      el.addEventListener('click', (e) => {
        e.preventDefault();
        const i = el.getAttribute('data-index');
        const id = el.getAttribute('data-id');
        this.removeCartItemByIndex(i, id);
      })
    })

  }

  renderEmpty() {

    let cartMarkup = ``;

    const max = parseInt(this.getAttribute('data-max-items'), 10);
    const placeholderImage = this.getAttribute('data-placeholder-image');
    let loopedHTML = '';

    for (let index = 0; index < max; index++) {
      loopedHTML += `<div class="sampleBuilder__line-empty">
          <img src="${placeholderImage}" alt="Skeleton Image">
          <div>Select Product</div>
        </div>`;
    }

    cartMarkup = loopedHTML;

    this.setAttribute('data-count', 0);
    this.querySelector('[data-dynamic-cart-ref]').innerHTML = `${cartMarkup}`;
  }



  removeCartItemByIndex(indexToRemove, id) {
    const localStorageKey = "ecsSamplesMiniCart";
    const rawData = localStorage.getItem(localStorageKey);

    if (!rawData) return;

    try {
      const parsed = JSON.parse(rawData);

      if (!Array.isArray(parsed.composition)) {
        parsed.composition = [];
      }

      if (indexToRemove >= 0 && indexToRemove < parsed.composition.length) {
        parsed.composition.splice(indexToRemove, 1);
      }

      localStorage.setItem(localStorageKey, JSON.stringify(parsed));

      this.renderCart(localStorage.getItem(localStorageKey), false);

      document.querySelector(`#ecs_component-add-${id}`).classList.remove('added');

    } catch (e) {
      console.error("Failed to remove item from cart:", e);
    }
  }

}

customElements.define("ecs-sample-mini-cart", SampleMiniCart);





class SampleMiniCartProcess extends HTMLElement {
  constructor() {
    super();

    this.querySelector('button').addEventListener('click', (e) => {
      e.preventDefault();
      this.addToMainCart();
    })

  }


  async addToMainCart() {

    // first get the mini cart data

    const localStorageKey = "ecsSamplesMiniCart";
    const existing = localStorage.getItem(localStorageKey);

    const now = Date.now();


    const getCart = await fetch(window.Shopify.routes.root + 'cart.js', {
      method: 'GET',
      headers: {
        'Content-Type': 'application/json',
      },
    });

    const latestCartData = await getCart.json();

    const updates = {};

    latestCartData.items.forEach((item) => {
      if (item.has_components && item.product_type === "bundle") {
        updates[item.key] = 0;
      }
    });

    if (Object.keys(updates).length > 0) {
      const cartRequest = await fetch(window.Shopify.routes.root + 'cart/update.js', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
        },
        body: JSON.stringify({
          updates
        }),
      });
    }


    if (existing) {
      try {
        const parsed = JSON.parse(existing);

          const properties = {
            _c: parsed.composition.map(item => item.id).join(',')
          };

          const dataToAdd = {
            items: [{
              id: parsed?.item,
              quantity: 1,
              properties: properties
            }]
          }

          const cartRequest = await fetch(window.Shopify.routes.root + 'cart/add.js', {
            method: 'POST',
            headers: {
              'Content-Type': 'application/json'
            },
            body: JSON.stringify(dataToAdd)
          })

          const cartRequestData = await cartRequest.json();

          if (cartRequest.ok) {
            const localStorageKey = "ecsSamplesMiniCart";
            const now = Date.now();
            this.closest('ecs-sample-mini-cart').createFreshCart(localStorageKey, now);

            const locale = window?.Shopify?.routes?.root;

            // if (locale == "/") {
            //   window.location.href = `?cart-open=true`;
            // } else {
            //   let r = locale.replace(/\/$/, "");
            //   window.location.href = `${r}?cart-open=true`;
            // }

            window.location.href = `?cart-open=true`;



          } else if (cartRequestData?.status == 422) {
            this.displayError(cartRequestData?.message);
          }

        
      } catch (error) {
        console.error('Error:', error);
      }
    }


    // then form the single cart line with attributes

    // add to cart 

    // cleat loccal mini cart

  }


  displayError(text) {
    this.querySelector('#errors').innerHTML = `<span>${text}</span>`;

    setTimeout(() => {
      this.querySelector('#errors').innerHTML = ``;
    }, 5000)
  }

}

customElements.define("ecs-sample-mini-cart-process", SampleMiniCartProcess);




class SampleMiniClear extends HTMLElement {
  constructor() {
    super();

    const key = "ecsSamplesMiniCart";
    const now = Date.now();

    this.addEventListener('click', (e) => {
      e.preventDefault();
      this.clearCart(key, now);
    })

  }

  async clearCart(key, timestamp) {

    localStorage.removeItem(key);

    // check for admin forced items

    let compositionData = [];

    let forcedItems = this.getAttribute('data-f');
    if (forcedItems) {
      const variantIDs = JSON.parse(forcedItems);
      const variantGIDs = variantIDs.map(id => `gid://shopify/ProductVariant/${id}`);

      const SHOPIFY_STOREFRONT_API_URL = 'https://escentric.myshopify.com/api/2025-07/graphql.json';
      const STOREFRONT_ACCESS_TOKEN = '40fd225a07783109214bb76e61638855';

      const VARIANTS_QUERY = `
        query getVariants($ids: [ID!]!) {
          nodes(ids: $ids) {
            ... on ProductVariant {
              id
              title
              quantityAvailable
              image {
                url
              }
              product {
                id
                title
              }
            }
          }
        }
      `;

      function chunkArray(array, size) {
        return Array.from({
            length: Math.ceil(array.length / size)
          }, (_, i) =>
          array.slice(i * size, i * size + size)
        );
      }

      async function fetchVariantChunk(idsChunk) {
        const response = await fetch(SHOPIFY_STOREFRONT_API_URL, {
          method: 'POST',
          headers: {
            'Content-Type': 'application/json',
            'X-Shopify-Storefront-Access-Token': STOREFRONT_ACCESS_TOKEN,
          },
          body: JSON.stringify({
            query: VARIANTS_QUERY,
            variables: {
              ids: idsChunk
            },
          }),
        });

        const json = await response.json();

        if (json.errors) {
          console.error('Storefront API Errors:', json.errors);
          throw new Error('Storefront API returned errors');
        }

        return json.data.nodes;
      }

      async function fetchVariantsByIds(allVariantIds) {
        const chunks = chunkArray(allVariantIds, 10);
        const results = [];

        for (const chunk of chunks) {
          const data = await fetchVariantChunk(chunk);
          results.push(...data);
        }

        return results;
      }

      // fetch products that are forced to form data in minicart
      try {
        const allVariants = await fetchVariantsByIds(variantGIDs);

        // with the returned data, push to the mini cart

        allVariants.map((v) => {
          compositionData.push({
            id: v?.id?.split('/').pop(),
            image: v?.image?.url,
            quantity: 1,
            title: v?.product?.title,
            variant: v?.title
          })
        })


        const newCartWithForcedItems = {
          createdAt: timestamp,
          item: this.getAttribute('data-product-id'),
          composition: compositionData
        };

        localStorage.setItem(key, JSON.stringify(newCartWithForcedItems));

        setTimeout(() => {
          this.closest('[data-cart-ref]').renderCart(localStorage.getItem(key), false);
        }, 500)


        document.querySelectorAll('.ecs-component-add').forEach((el) => {
          el.classList.remove('added');
        })

      } catch (err) {
        console.error('Failed to fetch variants:', err);
      }
    } else {

      const newCart = {
        createdAt: timestamp,
        item: this.getAttribute('data-product-id'),
        composition: []
      };

      localStorage.setItem(key, JSON.stringify(newCart));
      this.closest('[data-cart-ref]').renderEmpty();

      document.querySelectorAll('.ecs-component-add').forEach((el) => {
        el.classList.remove('added');
      })
    }


  }


}

customElements.define("ecs-mini-cart-remove-all", SampleMiniClear);




class SampleFilter extends HTMLElement {
  constructor() {
    super();

    this.querySelectorAll('.sampleBuilder__filter-option').forEach((el)=>{
      el.addEventListener('click',(e)=>{
        this.removeActiveStatus();
        el.classList.add('active');
        this.setAttribute('data-kind', el.getAttribute('data-filter'));
      })
    })

  }


  static get observedAttributes() {
    return ["data-kind"];
  }


  attributeChangedCallback(name, oldValue, newValue){
    let dataKind = this.getAttribute("data-kind");

    if(name == 'data-kind'){
    this.filterByCat(dataKind);
    }
  }

  removeActiveStatus() {
    this.querySelectorAll('.sampleBuilder__filter-option').forEach((el)=> {
      el.classList.remove('active');
    })
  }


  filterByCat(d){

    if(d == "all"){
      document.querySelectorAll('.ecs-filterable').forEach((i)=>{
        i.parentElement.classList.remove('visually-hidden');
      })
    } else {
      document.querySelectorAll('.ecs-filterable').forEach((c,i)=>{
        if(c.dataset.kind.includes(d) || c.dataset.kind == d){
          c.parentElement.classList.remove('visually-hidden');
        } else {
          c.parentElement.classList.add('visually-hidden');
        }
      })
      
    }
  }


}

customElements.define("ecs-filters", SampleFilter);